// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__3FYRm","desc":"style_desc__1JGdu","tips":"style_tips__1ab4n","entrance":"style_entrance__2-3ek"};